<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
@import 'assets/styles/reset.scss';
@import 'assets/styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue